
const PROJECT = window.Anatec.constants.PROJECT_ENV;
// TODO change this after extraction from ruby codebase"
const constants = {
  wesave: require('./constants/constants.wesave'),
  bforbank: require('./constants/constants.bforbank')
}

module.exports = Object.assign({}, {PROJECT: PROJECT}, constants[PROJECT]);
